/**
 * Shared logout routine (Header / Footer).
 * ล้างเฉพาะ key ที่เกี่ยวกับ auth เพื่อให้ "จำการเข้าสู่ระบบ" ยังทำงานได้
 */
const AUTH_KEYS = [
  "user",
  "userId",
  "token",
  "authToken",
  "accessToken",
  "refreshToken",
  "currentUser",
  "persist:root",
];

export default function performLogout(logout) {
  try {
    if (typeof logout === "function") logout();
  } catch (e) {
    console.error("Logout error:", e);
  }
  try {
    AUTH_KEYS.forEach((k) => localStorage.removeItem(k));
    sessionStorage.clear();
  } catch (_) {
    // ignore storage errors
  }
  window.location.href = "/";
}
